import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CircularProgress from '@mui/material/CircularProgress';
import PeopleIcon from '@mui/icons-material/People';

const C = {
  accent: '#2dd4bf', bg: '#f0f4f4', card: '#ffffff',
  cardBorder: 'rgba(0,0,0,0.06)', text: '#1a2e2e', muted: '#5a7a7a',
  shadow: '0 2px 10px rgba(0,0,0,0.07)', danger: '#ef4444',
};
const inp = { border: `1px solid ${C.cardBorder}`, borderRadius: '7px', fontSize: '12px', height: '28px', width: '100%', padding: '0 8px', outline: 'none', backgroundColor: '#f8fafa', boxSizing: 'border-box', fontFamily: 'inherit' };
const card = { backgroundColor: C.card, borderRadius: '10px', boxShadow: C.shadow, border: `1px solid ${C.cardBorder}`, marginBottom: '10px', overflow: 'hidden' };
const cardHead = (color = C.accent) => ({ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 12px', borderBottom: `1px solid ${C.cardBorder}`, backgroundColor: `${color}18`, fontSize: '10px', fontWeight: 700, color: C.text, textTransform: 'uppercase', letterSpacing: '0.5px' });
const cardBody = { padding: '10px 12px' };
const lbl = { fontSize: '9.5px', fontWeight: 700, color: C.muted, textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '3px' };

const UserCreate = () => {
  const history = useHistory();
  const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();

  const [isLoading, setIsLoading] = useState(false);
  const [firstName, setFirstName]       = useState('');
  const [lastName, setLastName]         = useState('');
  const [userName, setUserName]         = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [email, setEmail]               = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage]     = useState('');

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
  }, [isAuthenticated, companyId, token, logout]);

  useEffect(() => {
    const generated = `${firstName.toLowerCase()}_${lastName.toLowerCase()}`.slice(0, 12);
    setUserName(generated);
  }, [firstName, lastName]);

  const submitData = async (e) => {
    e.preventDefault();
    if (!firstName) { setErrorMessage('First Name is required!'); return; }
    if (!lastName)  { setErrorMessage('Last Name is required!'); return; }
    if (!contactNumber) { setErrorMessage('Contact Number is required!'); return; }
    if (!email)     { setErrorMessage('Email is required!'); return; }
    setIsLoading(true);
    try {
      await postData('UserApi', { FirstName: firstName, LastName: lastName, UserName: userName, Email: email, ContactNumber: contactNumber, CreatedBy: userId, CompanyId: companyId, StaffId: userId, CreatedDate: new Date() }, token);
      setSuccessMessage('User Created Successfully!');
      history.push('/UserIndex');
    } catch (err) {
      console.error('Error creating user:', err);
      setErrorMessage('Failed to create user. Please try again.');
    } finally { setIsLoading(false); }
  };

  return (
    <div style={{ fontFamily: 'Segoe UI, sans-serif', fontSize: '12px', width: '100%', padding: '6px', boxSizing: 'border-box', backgroundColor: C.bg }}>

      {/* ── Header ── */}
      <div style={{ ...card, overflow: 'visible' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', flexWrap: 'wrap', gap: '8px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <PeopleIcon style={{ fontSize: 16, color: C.accent }} />
            <span style={{ fontWeight: 800, fontSize: '13px', color: C.text, fontFamily: 'Inter, sans-serif' }}>Create User</span>
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={submitData} disabled={isLoading}
              style={{ height: '28px', padding: '0 16px', borderRadius: '7px', border: 'none', backgroundColor: C.accent, color: '#fff', fontWeight: 700, fontSize: '11px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', fontFamily: 'inherit' }}>
              {isLoading ? <CircularProgress size={13} sx={{ color: '#fff' }} /> : '✓ Save'}
            </button>
            <Link to="/UserIndex"
              style={{ height: '28px', padding: '0 14px', borderRadius: '7px', border: `1px solid ${C.cardBorder}`, backgroundColor: C.card, color: C.muted, fontWeight: 600, fontSize: '11px', display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
              ← Back
            </Link>
          </div>
        </div>
      </div>

      {errorMessage   && <div style={{ marginBottom: '8px', padding: '6px 12px', backgroundColor: '#fef2f2', border: '1px solid #fecaca', borderRadius: '7px', fontSize: '11px', color: C.danger }}>{errorMessage}</div>}
      {successMessage && <div style={{ marginBottom: '8px', padding: '6px 12px', backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '7px', fontSize: '11px', color: '#16a34a' }}>{successMessage}</div>}

      {/* ── User Details ── */}
      <div style={card}>
        <div style={cardHead()}>👤 User Details</div>
        <div style={{ ...cardBody, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '10px' }}>
          <div>
            <label style={lbl}>First Name <span style={{ color: C.danger }}>*</span></label>
            <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} placeholder="First Name" maxLength={30} style={inp} />
          </div>
          <div>
            <label style={lbl}>Last Name <span style={{ color: C.danger }}>*</span></label>
            <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} placeholder="Last Name" maxLength={30} style={inp} />
          </div>
          <div>
            <label style={lbl}>User Name</label>
            <input type="text" value={userName} readOnly style={{ ...inp, backgroundColor: '#f0f4f4', cursor: 'default' }} />
          </div>
          <div>
            <label style={lbl}>Contact Number <span style={{ color: C.danger }}>*</span></label>
            <input type="text" value={contactNumber} onChange={e => setContactNumber(e.target.value)} placeholder="Contact Number" maxLength={15} style={inp} />
          </div>
          <div>
            <label style={lbl}>Email <span style={{ color: C.danger }}>*</span></label>
            <input type="text" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" maxLength={40} style={inp} />
          </div>
        </div>
      </div>

    </div>
  );
};

export default UserCreate;
